module.exports = __webpack_public_path__ + "img/bdbdc44.png";